module.exports = __webpack_public_path__ + "fonts/footable.91c34385.eot";